import { createAuthGuard } from '@auth0/auth0-vue';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import auth0Plugin from './auth';
import { installComponents } from './components';
import App from './components/app/App.vue';
import { useSentry } from './plugins/sentry';
import { globalRoutes } from './routes/global';
import { ressursRoutes } from './routes/ressurs';
import { timerRoutes } from './routes/timer';
import { awaitUser, useUserStore } from './stores/user';
import './styles/main.css';
import { gateRedirect } from './utilities/router';
import {
  notifyServiceWorkerMounted,
  setupServiceWorkerUpdates,
  setupStaleChunkReload,
  setupStaleTabReload,
} from './utilities/serviceWorker';

const auth0Guard = createAuthGuard();

setupServiceWorkerUpdates();
setupStaleTabReload();
setupStaleChunkReload();

const app = createApp(App);

const router = createRouter({
  history: createWebHistory(),
  routes: [...globalRoutes, ...timerRoutes, ...ressursRoutes],
});

const pinia = createPinia();

// Vue plugins
app.use(router);
app.use(VueQueryPlugin, {
  enableDevtoolsV6Plugin: true,
});
app.use(auth0Plugin);

app.use(pinia);

useSentry(app, router);

router.beforeEach(async (to) => {
  if (to.path === '/callback' || to.path === '/logout' || to.path === '/Logout') {
    return true;
  }

  const ok = await auth0Guard(to);
  if (!ok) return false;

  const userStore = useUserStore();
  await awaitUser;

  const redirect = gateRedirect(to, userStore);
  if (redirect) return redirect;
});

// Vue global components
installComponents(app);

// Mount vue app to DOM
app.mount('#app');

notifyServiceWorkerMounted();
